import { ANO_MATRICULAS } from '../../../config/anoLetivo';

// Faixa "Matrículas abertas". Antes ficava na página Matricule-se; agora está
// na página inicial. O id "matricule-se" é usado pelos links antigos
// (/matricule-se redireciona para /inicio#matricule-se).
const DestaqueMatriculasSection = () => (
  <section id="matricule-se" className="destaque-matriculas" aria-label={`Matrículas ${ANO_MATRICULAS} abertas`}>
    <span className="destaque-selo">Matrículas {ANO_MATRICULAS} abertas</span>
    <p className="destaque-texto">
      Garanta a vaga do seu filho para {ANO_MATRICULAS}. Venha conhecer o Colégio Líder e
      converse com a nossa equipe.
    </p>
    <a href="https://wa.me/5562998271550" target='_blank' rel='noreferrer' className="cta-button destaque-botao">
      Quero agendar uma visita
    </a>
  </section>
);

export default DestaqueMatriculasSection;
